import _ from 'lodash'

const initState = {
    services: [ // services under 

    ],
    classes: [ // class, event, workshop, retreat, etc... 
        
    ],
    products: [ // Digital products

    ],
    connectedAccounts: [

    ],
    inProgress: false,
    zoomConnected: false
}
export const ADD_SCHEDULED_CLASS = "ADD_SCHEDULED_CLASS"
export const ADD_SCHEDULED_CLASSES = "ADD_SCHEDULED_CLASSES"
export const UPDATE_SCHEDULED_CLASS = "UPDATE_SCHEDULED_CLASS"
export const SET_ZOOM_CONNECTED = "SET_ZOOM_CONNECTED"
export const SET_CONNECTED_ACCOUNTS = "SET_CONNECTED_ACCOUNTS"

export const UPDATE_SERVICE = "UPDATE_SERVICE"
export const ADD_SERVICE = "ADD_SERVICE"
export const DELETE_SERVICE = "DELETE_SERVICE"
export const IN_PROGRESS = "IN_PROGRESS"

const schedulingReducer = (state = initState, action) => {
    switch (action.type) {
        case 'SET_SERVICES':
            // state.services = action.services;
            return {
                ...state,
                services: action.services
            }
            // return state;
        case DELETE_SERVICE:
            const servicesAfterDelete = _.filter(state.services, function(x) { return x?.id !== action?.service?.id; });
            return {
                ...state,
                services: servicesAfterDelete
            }

        case UPDATE_SERVICE:
            return {
                ...state,
                services: state.services.map(item => {
                    if (item.id === action.service.platformID) {
                        return {
                            ...item,
                            ...action.service
                        }
                    }
                    return item
                })
            }
        case ADD_SERVICE:
            return {
                ...state,
                services: [...state.services].concat(action.service)
            }
        case 'SET_SCHEDULED_CLASSES':
            // state.classes = action.classes;
            return {
                ...state,
                classes: action.classes
            }
            // return state;
        case ADD_SCHEDULED_CLASS:
            return {
                ...state,
                classes: [...state.classes].concat(action.class)
            }
        case ADD_SCHEDULED_CLASSES:
            return {
                ...state,
                classes: [...state.classes].concat(action.classes)
            }
        case SET_CONNECTED_ACCOUNTS:
            return {
                ...state,
                connectedAccounts: action.connectedAccounts
            }
        case UPDATE_SCHEDULED_CLASS:

            return {
                ...state,
                classes: state.classes.map(item => {
                    if (item.id === action.class.platformID) {
                        return action.class
                    }
                    return item
                })
            }
            // const classIndex = state.classes.findIndex((val) => val?.platformID === action?.class?.platformID)
            // if (classIndex) {
            //     state.classes[classIndex] = action.class
            //     return state
            // }
            // break
        case SET_ZOOM_CONNECTED:
            return {
                ...state,
                zoomConnected: action.connected
            }
        case IN_PROGRESS:
            // state.inProgress = action.inProgress;
            return {
                ...state,
                inProgress: action.inProgress
            }
            // return state
    }

    return state
}

export default schedulingReducer;